<template>
  <div>
    <div v-if="Error" class="error">{{ Error }}</div>

    <div v-else class="grid">
      <!-- Tarjeta predeterminada si no hay familiares -->
      <div v-if="!Familiares.length" class="card">
        <v-card class="mx-auto" max-width="300">
          <v-img src="https://cdn-icons-png.flaticon.com/512/194/194931.png" height="200px" coverF></v-img>
          <v-card-title>Nombre Apellido</v-card-title>
          <v-card-subtitle>correo@ejemplo.com</v-card-subtitle>
        </v-card>
      </div>

      <div v-for="(familiar, index) in Familiares" :key="familiar.id_persona" class="card">
        <v-card>
          <v-card-text>
            <v-img style="margin: 0 auto" class="d-block" width="200" height="200px" :src="familiar.avatar_persona
              ? URL_SPACE + `/${familiar.ruta_avatar_persona}`
              : 'https://cdn-icons-png.flaticon.com/512/3048/3048148.png'
              "></v-img>
          </v-card-text>
          <v-card-title class="d-flex justify-center">
            {{ familiar.nombre_persona + " " + familiar.ape1_persona }}
          </v-card-title>

          <v-card-subtitle class="text-center">{{ familiar.correo_persona || "usuario sin correo" }} </v-card-subtitle>
          <v-card-actions >
            <v-row dense>
              <v-col cols="12" class="d-flex justify-center">
                <v-btn color="orange-lighten-2" variant="text" @click="toggleDetails(index)">
                  {{ !expandedStates[index] ? "Más detalles" : "Menos detalles" }}
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>

          <v-expand-transition>
            <div v-show="expandedStates[index]">
              <v-divider></v-divider>

              <v-card-text>
                <p>
                  <v-icon small  >fa-id-card-alt</v-icon>
                  <strong class="primary--text px-2"  >Número de documento:</strong>
                  {{
                    familiar.numdoc_persona ||
                    "Debe llenar este campo para visualizar"
                  }}
                </p>
                <p>
                  <v-icon small >fa-phone</v-icon>
                  <strong class="primary--text px-2">Teléfono:</strong>
                  {{
                    familiar.telf_persona ||
                    "Debe llenar este campo para visualizar"
                  }}
                </p>
                <p>
                  <v-icon small >fa-calendar-alt</v-icon>
                  <strong class="primary--text px-2">Fecha de nacimiento:</strong>
                  {{
                    familiar.fecnac_persona ||
                    "Debe llenar este campo para visualizar"
                  }}
                </p>
                <p>
                  <v-icon small>fa-flag</v-icon>
                  <strong class="primary--text px-2" >Nacionalidad:</strong>
                  {{
                    getNacionalidadDesc(familiar.id_nacionalidad) || "Debe llenar este campo para visualizar" }}
                </p>
                <p>
                  <v-icon small >
                    {{ familiar.sexo_persona === "F" ? "fa-regular fa-venus" : "fa-solid fa-mars" }}
                  </v-icon>
                  <strong class="primary--text px-2">Sexo:</strong>
                  {{
                    familiar.sexo_persona === "F"
                    ? "Femenino"
                    : "Masculino" || "Debe llenar este campo para visualizar"
                  }}
                </p>
                <p>
                  <v-icon small >fa-sharp fa-solid fa-suitcase</v-icon>
                  <strong class=" px-2 primary--text">Profesión:</strong>
                  {{
                    familiar.profesion_familia ||
                    "Debe llenar este campo para visualizar"
                  }}
                </p>
                <!-- <p>
                  <strong style="color: #1565c0">Ocupación:</strong>
                  {{
                    familiar.ocupacion_familia ||
                    "Debe llenar este campo para visualizar"
                  }}
                </p> -->
                <p>
                  <v-icon small >fa-map-marker-alt</v-icon>
                  <strong class=" px-2 primary--text">Dirección personal:</strong>
                  {{
                    familiar.direc_persona ||
                    "Debe llenar este campo para visualizar"
                  }}
                </p>
                <p>
                  <v-icon small>fa-map-marker-alt</v-icon>
                  <strong class=" px-2 primary--text">Dirección laboral:</strong>
                  {{
                    familiar.direccion_trabajo ||
                    "Debe llenar este campo para visualizar"
                  }}
                </p>
              </v-card-text>
            </div>
          </v-expand-transition>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import { API_URL, BUCKET_ORIGIN_SPACE } from '@/helpers/axios.js';
export default {
  name: "MisFamiliares",
  props: ["Familiares", "Error", "Nacionalidades"],
  data: () => ({
    expandedStates: [],
    API_URL: API_URL,
    URL_SPACE: BUCKET_ORIGIN_SPACE,
  }),
  methods: {
    toggleDetails(index) {
      this.$set(this.expandedStates, index, !this.expandedStates[index]);
    },
    getNacionalidadDesc(id) {
      const nacionalidadObj = this.Nacionalidades.find(n => n.id === id);
      return nacionalidadObj ? this.capitalizeFirstLetter(nacionalidadObj.desc_nacionalidad) : "Nacionalidad desconocida";
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
    },
  },
};
</script>

<style scoped>
.error {
  color: red;
  margin-bottom: 20px;
  height: 150px;
  width: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 15px;
  background-color: rgb(228, 228, 228) !important;
  font-size: 18px;
  font-weight: 600px;
}

.grid {
  display: flex;
  flex-wrap: wrap;
  position: relative;
  /* Esto es importante para asegurar que las tarjetas expandidas se basen en este contenedor */
  gap: 30px;
  margin: 10px;
}
</style>
